import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=69c81a37&scoped=true&"
import script from "./Title.vue?vue&type=script&lang=js&"
export * from "./Title.vue?vue&type=script&lang=js&"
import style0 from "./Title.vue?vue&type=style&index=0&id=69c81a37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c81a37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c81a37')) {
      api.createRecord('69c81a37', component.options)
    } else {
      api.reload('69c81a37', component.options)
    }
    module.hot.accept("./Title.vue?vue&type=template&id=69c81a37&scoped=true&", function () {
      api.rerender('69c81a37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Layouts/components/Title.vue"
export default component.exports